<template>
    <v-dialog
    v-model="shown"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Klient
      </v-card-title>

      <v-card-text>
        <form @submit.prevent="save">
          <v-row>
            <v-col>
              <v-text-field
                v-model="query"
              />
            </v-col>
          </v-row>
          <v-row v-show="loading">
            <v-col class="text-center">
              <AppSpinner />
            </v-col>
          </v-row>
          <v-row class="results" v-show="!loading && results.length">
            <v-col cols="12" class="pa-0" v-for="result in results" :key="result.tax_number">
              <BuyerInfoCard
                :result="result"
                :selected="selected === result.tax_number"
                @click="toggleSelected(result)"
              />
            </v-col>
          </v-row>
          <div style="height: 30px; margin-top: 20px;">
            <v-btn type="submit" class="float-right">Dodaj</v-btn>
            <v-btn text type="button" class="float-right mr-4" @click="remove">Prekliči</v-btn>
          </div>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BuyerInfoCard from './BuyerInfoCard'
import { siIncludes } from '@/utils/str'

export default {
  components: {
    BuyerInfoCard
  },
  data () {
    return {
      results: [],
      selected: null,
      query: null,
      loading: false,
      shown: false,
      typingTimer: null,
      doneTypingInterval: 700
    }
  },
  computed: {
    buyerSelected () {
      return this.selected !== null
    }
  },
  methods: {
    ...mapActions('companies', ['businessRegister']),
    // ...mapActions('clients', ['loadItems']),
    search () {
      this.loading = true
      this.businessRegister(this.query)
        .then(results => {
          this.results = results.slice(0, 10)
          this.loading = false
        })
      /* this.loadItems()
        .then(results => {
          this.results = Object.values(results).filter(client => {
            return siIncludes({ haystack: client.name, needle: this.query }) || (client.tax_number + '').includes(this.filter)
          })
          this.loading = false
        }) */
    },
    save () {
      const buyer = this.results.find(result => result.tax_number === this.selected)
      buyer.country = 'Slovenija' // todo - if buyer is found in the register country is allways slovenia, when added manually we should override (also in app)
      this.$emit('save', buyer)
      this.shown = false
    },
    remove () {
      this.$emit('removeBuyer')
      this.shown = false
    },
    open () {
      this.results = []
      this.selected = null
      this.query = ''
      this.shown = true
    },
    toggleSelected (result) {
      if (this.selected === result.tax_number) {
        this.selected = null
      } else {
        this.selected = result.tax_number
      }
    }
  },
  watch: {
    query (query) {
      clearTimeout(this.typingTimer)
      if (query) {
        this.typingTimer = setTimeout(this.search, this.doneTypingInterval)
      } else {
        this.results = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .results {
    max-height: calc(80vh - 250px);
    padding: 10px;
    overflow-y: auto;
  }
</style>
